import type { DripsyColor } from "@utils";
import { useDripsyColor } from "@utils";
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";

function FacebookIcon({ size, color }: { size: number; color: DripsyColor }) {
  const finalColor = useDripsyColor({ color });
  return (
    <Svg width={size} height={size} viewBox="0 0 80 80">
      <G id="CC" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <G id="facebook-circular-logo" fill={finalColor} fillRule="nonzero">
          <Path
            d="M40.0002386,0 C17.908945,0 0,17.9838164 0,40.1674663 C0,60.0636084 14.4208712,76.5409472 33.3289991,79.7316706 L33.3289991,48.5474877 L23.6797748,48.5474877 L23.6797748,37.3255709 L33.3289991,37.3255709 L33.3289991,29.0509646 C33.3289991,19.4500446 39.1685405,14.2181015 47.6988136,14.2181015 C51.7842977,14.2181015 55.2952755,14.5238052 56.3144992,14.6584491 L56.3144992,24.6939668 L50.3981343,24.6968417 C45.7600935,24.6968417 44.8658869,26.9096006 44.8658869,30.1578232 L44.8658869,37.319821 L55.9327675,37.319821 L54.4893443,48.5417378 L44.8658869,48.5417378 L44.8658869,80 C64.6567695,77.5812026 80,60.6841201 80,40.1559664 C80,17.9838164 62.091055,0 40.0002386,0 Z"
            id="Path"
          />
        </G>
      </G>
    </Svg>
  );
}
export default FacebookIcon;
